import * as api from "./modules/api";
import * as modal from "./modules/modal";
import * as legacy from "./modules/legacy/api";

import { fireEvent } from "./modules/events";
import { handleError } from "./modules/errors";
import checkBrowserVersion from "./modules/browsers";
import { checkPackageVersion, getPackageVersion, getPackageVersionInfo } from "./modules/package";

// config checker options
let appendVersionToUrl = false;
let checkConfiguration = false;
let ignoreValidation = false;
let forceAccess = false;

const ConfigChecker = {
    // main entry point
    checkSecurityPackage: function(){
        const options = { appendVersionToUrl, checkConfiguration, ignoreValidation, forceAccess };
        if (typeof arguments[0] === 'object') Object.assign(options, arguments[0]);

        // set config checker options
        if (options.appendVersionToUrl === true || arguments[0] === true) appendVersionToUrl = true; // add version number to url when redirecting
        if (options.checkConfiguration === true || arguments[1] === true) checkConfiguration = true; // allow card reader checks
        if (options.ignoreValidation === true) ignoreValidation = true;
        if (options.forceAccess === true) forceAccess = true;

        fireEvent('loading');
        // check browser version
        checkBrowserVersion(true)
            .then(result => {
                const browserCheck = result;
                if (browserCheck.authorized === true) {
                    if(browserCheck.deprecated && !forceAccess) {
                        modal.showDeprecatedBrowserMessage();
                    } else {
                        // check security components
                        api.isServiceAvailable()
                            .then(api.isVersionAuthorized)
                            .then(result => {
                                const msiVersion = result.version;
                                const successEvent = result.prototype === true ? 'newerVersion' : result.deprecated === true ? 'oldVersion' : 'acceptedVersion';
                                if (checkConfiguration) {
                                    if (browserCheck.legacy === false || legacy.checkBrowserSettings() === true) {
                                        // proceed with device check
                                        api.isCardReaderAvailable()
                                            .then(api.isCardCertificateValid)
                                            .then(() => {
                                                if (((browserCheck.platform === 'windows' && msiVersion < '6.30.0008') || (browserCheck.platform === 'macintosh' && msiVersion < '6.32.0031')) && !forceAccess) {
                                                    modal.showSecurityWarningMessage(); //intelligate warning message
                                                }  else {
                                                    fireEvent(successEvent);
                                                }
                                            })
                                            .catch(handleError);
                                    }
                                } else {
                                    fireEvent(successEvent);
                                }
                            })
                            .catch(handleError);
                    }
                } else {
                    handleError('wrongBrowser');
                }
            });
    }
};

Object.assign(ConfigChecker, {
    getLibraryVersion: () => '1.0.0',
    // configuration
    setMessage: api.setMessage,
    setAction: api.setAction,
    setUrl: api.setRedirect,
    // expose api
    checkBrowserVersion,
    checkPackageVersion,
    getPackageVersionInfo,
    isServiceAvailable: api.isServiceAvailable,
    isVersionAuthorized: api.isVersionAuthorized,
    isCardReaderAvailable: api.isCardReaderAvailable,
    isIsabelCardReaderAvailable: api.isIsabelCardReaderAvailable,
    isCardCertificateValid: api.isCardCertificateValid,
    isIsabelCardAvailable: api.isIsabelCardAvailable
});

Object.assign(window, {
    ConfigChecker,
    // legacy methods
    getloadedMSIVersion: getPackageVersion,
    updateBrowser: legacy.updateBrowser,
    continueToApplication: legacy.continueToApplication,
    hideWarningMessage: modal.hideSecurityWarningMessage
});